import { apiRequest, buildURL } from './commons/CommonService.Functions';

/**
 * Preferencias de interfaz del usuario autenticado (Persons.API, `/persons/user-settings`).
 * El usuario sale del token: la API no recibe ni devuelve ids de usuario.
 */

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

export interface UserSettingViewModel {
  key: string;
  /** Valor tal como se guardó (normalmente JSON serializado). */
  value: string;
  created: string;
  lastModified?: string | null;
}

/** Todas las preferencias del usuario. */
export const GetUserSettings = async (token: string): Promise<UserSettingViewModel[]> =>
  apiRequest<UserSettingViewModel[]>(buildURL(BaseURL, 'user-settings'), token, 'GetUserSettings');

/** Una preferencia por clave. Rechaza con `ErrorCode` 404 si el usuario todavía no la guardó. */
export const GetUserSetting = async (token: string, key: string): Promise<UserSettingViewModel> =>
  apiRequest<UserSettingViewModel>(buildURL(BaseURL, 'user-settings', key), token, 'GetUserSetting');

/** Crea o reemplaza una preferencia (idempotente). */
export const PutUserSetting = async (token: string, key: string, value: string): Promise<UserSettingViewModel> =>
  apiRequest<UserSettingViewModel>(buildURL(BaseURL, 'user-settings', key), token, 'PutUserSetting', {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });

export const DeleteUserSetting = async (token: string, key: string): Promise<number> =>
  apiRequest<number>(buildURL(BaseURL, 'user-settings', key), token, 'DeleteUserSetting', { method: 'DELETE' });
